import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/external-login',
    name: 'ExternalLogin',
    component: () => import('../views/ExternalLogin.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dingtalk',
    children: [
      {
        path: 'bind-success',
        name: 'DingTalkBindSuccess',
        component: () => import('../views/DingTalkBindSuccess.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: 'bind-fail',
        name: 'DingTalkBindFail',
        component: () => import('../views/DingTalkBindFail.vue'),
        meta: { requiresAuth: false }
      }
    ]
  },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import('../views/Invoice.vue')
      },
      {
        path: 'tag',
        name: 'Tag',
        component: () => import('../views/Tag.vue')
      },
      {
        path: 'project',
        name: 'Project',
        component: () => import('../views/Project.vue')
      },
      {
        path: 'reimbursement',
        name: 'Reimbursement',
        component: () => import('../views/Reimbursement.vue')
      },
      {
        path: 'payment-bill',
        name: 'PaymentBill',
        component: () => import('../views/PaymentBill.vue')
      },
      {
        path: 'mail-ingest-log',
        name: 'MailIngestLog',
        component: () => import('../views/MailIngestLog.vue')
      },
      {
        // 不加 meta：普通用户可看自己发的记录（含自己的待认领），
        // 权限过滤在后端做 —— WecomMessageController 会把非 ADMIN 的 userId
        // 强制覆写成当前登录用户，并把两个姓名筛选参数置 null
        path: 'wecom-ingest-log',
        name: 'WecomIngestLog',
        component: () => import('../views/WecomIngestLog.vue')
      },
      {
        path: 'statistic',
        name: 'Statistic',
        component: () => import('../views/Statistic.vue')
      },
      {
        path: 'invoice-category',
        name: 'InvoiceCategory',
        component: () => import('../views/InvoiceCategory.vue')
      },

      {
        path: 'dingtalk/bind',
        name: 'DingTalkBind',
        component: () => import('../views/DingTalkBind.vue')
      },
      {
        path: 'wecom/bind',
        name: 'WecomBind',
        component: () => import('../views/WecomBind.vue')
      },
      {
        path: 'users',
        name: 'UserManage',
        component: () => import('../views/UserManage.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'department',
        name: 'Department',
        component: () => import('../views/Department.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'operation-log',
        name: 'OperationLog',
        component: () => import('../views/OperationLog.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'ai-model-config',
        name: 'AiModelConfig',
        component: () => import('../views/AiModelConfig.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'mail-config',
        name: 'MailConfig',
        component: () => import('../views/MailConfig.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'wecom-config',
        name: 'WecomConfig',
        component: () => import('../views/WecomConfig.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue')
      }
    ]
  },
  {
    // 兜底：未匹配的路径一律回登录页，避免空白页
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const mustChangePwd = store.state.userInfo && store.state.userInfo.mustChangePwd === 1
  if (to.meta.requiresAuth && !store.state.token) {
    next('/')
  } else if (to.path === '/' && store.state.token && !mustChangePwd) {
    // 需要强制改密的用户放行到 '/'（登录页自带改密弹窗），不再重定向到 /dashboard，
    // 否则会与其它分支的 next('/') 形成无限重定向
    next('/dashboard')
  } else if (to.meta.requiresAdmin && store.getters.userRole !== 'ADMIN') {
    next('/dashboard')
  } else if (to.path !== '/' && store.state.token && mustChangePwd) {
    next('/')
  } else {
    next()
  }
})

export default router